/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { Provider } from 'react-redux';
import { Settings } from 'luxon';

// Use consistent styling
// import 'semantic-ui-css/semantic.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/global.css';

// Import root app
import App from 'app';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'store/configureStore';
// import { injectStore } from 'utils/interceptors';

import { init as SentryInit, BrowserTracing } from '@sentry/react';

import reportWebVitals from 'reportWebVitals';

// Initialize languages
import './locales/i18n';
import { isRenderedInsideEmbed } from 'utils/isRenderedInsideEmbed';

// Initialize Redux
const { store } = configureAppStore();
// injectStore(store);

// Initialize Sentry
process.env.NODE_ENV !== 'development' &&
  SentryInit({
    dsn: 'https://5e91d60d87a457dfc0da2536f48661a1@o181936.ingest.sentry.io/4506342909935616',
    integrations: [new BrowserTracing()],

    tracesSampleRate: 1.0,
  });

// Configure Luxon to chnage the first day of the week
Settings.defaultWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7],
};

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

if (isRenderedInsideEmbed) {
  document.body.classList.add('is-rendered-inside-embed');
}

ReactDOMClient.createRoot(MOUNT_NODE!).render(
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  </Provider>,
);

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
